module.exports = __webpack_public_path__ + "static/img/3.cc165b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/3.png
// module id = 132
// module chunks = 2